import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateTheaterStats = (state: StatsSnapshot) => {
  const theater = state.generators.theater;

  const generatedTroupes = theater.owned * theater.baseGeneration;

  stats.theater = {
    buildingsGeneration: generatedTroupes,
  };
};
